import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import ReasonRow from './ReasonRow/ReasonRow'
import * as Styles from './styles'

const SizingIssuesRegions = ({ recommendationGlobal }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="allCapsM" color={theme.colors.text.muted}>
        {t('Todas las regiones')}
      </Text>

      <Styles.RowsContainer>
        {Object.entries(recommendationGlobal).map(([reason, data]) => (
          <ReasonRow key={reason} reason={reason} data={data} />
        ))}
      </Styles.RowsContainer>
    </Styles.Container>
  )
}

export default SizingIssuesRegions
